export const TRANSLATE_PREFIX = 'redeem-additional-info__';
